var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics-pie"},[_c('div',{staticClass:"statistics-pie__title"},[_vm._v("항목별 클릭 비율")]),_c('div',{staticClass:"statistics-pie__chart"},[_c('div',[_c('ve-pie',{attrs:{"width":"320px","height":"240px","judge-width":true,"resizeable":true,"legend-visible":false,"data":_vm.chartData,"settings":{
          dimension: 'type',
          metrics: 'value',
          radius: 70,
          offsetY: 130,
          itemStyle: {
            emphasis: {
              shadowBlur: 5,
              shadowColor: 'rgba(0, 0, 0, 0.2)',
            },
          },
        }}})],1),_c('div',{staticClass:"statistics-pie__chart-type"},[_c('ul',_vm._l((_vm.chartData.rows),function(item,index){return _c('li',{key:item.type},[_c('div',{staticClass:"color-box",style:(("background-color: " + (_vm.colorMap[index])))}),_c('span',[_vm._v(_vm._s(item.type))]),_vm._v(" "+_vm._s(item.value)+"%\n        ")])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }